{
  "entry": {
    "title": "医嘱录入",
    "subtitle": "计算机化医嘱录入（CPOE）",
    "searchSection": {
      "title": "搜索并添加医嘱",
      "cosignNotice": "您的医嘱在生效前需主治医生会签。"
    },
    "pending": {
      "title": "待提交医嘱",
      "clearAll": "全部清空",
      "collapseAria": "收起详情",
      "expandAria": "展开详情",
      "removeAria": "移除医嘱",
      "startDateTime": "开始日期/时间",
      "ariaStartDate": "医嘱开始日期",
      "ariaStartTime": "医嘱开始时间",
      "clinicalIndication": "临床指征",
      "clinicalIndicationPlaceholder": "开嘱原因…",
      "specialInstructions": "特殊说明",
      "specialInstructionsPlaceholder": "对执行科室的附加说明…",
      "diagnosisLabel": "诊断（ICD-10）",
      "diagnosisPlaceholder": "搜索 ICD-10 诊断代码…",
      "noActiveEncounter": "无有效就诊 — 无法下达医嘱。",
      "placing": "正在提交…",
      "placeAll": "提交全部医嘱（{{count}}）"
    },
    "active": {
      "title": "生效中医嘱",
      "loading": "正在加载医嘱…",
      "emptyAll": "未找到该患者的医嘱。",
      "emptyFiltered": "未找到{{type}}医嘱。",
      "columns": {
        "orderNumber": "医嘱号",
        "name": "名称",
        "type": "类型",
        "priority": "优先级",
        "status": "状态",
        "orderedBy": "开嘱医生",
        "orderedDate": "开嘱日期",
        "actions": "操作"
      },
      "external": "外部",
      "externalTitle": "来自 {{source}} 的外部医嘱",
      "externalTitleWithId": "来自 {{source}} 的外部医嘱 (#{{id}})",
      "providerPlaceholder": "医生 #{{id}}",
      "actions": {
        "complete": "完成",
        "cancel": "取消",
        "completeTooltip": "完成医嘱",
        "cancelTooltip": "取消医嘱"
      }
    },
    "cancelDialog": {
      "title": "取消医嘱",
      "prompt": "请提供取消 {{orderName}} 的原因。",
      "placeholder": "取消原因（必填）…",
      "goBack": "返回",
      "confirm": "确认取消"
    },
    "toast": {
      "cancelSuccess": "医嘱已成功取消",
      "cancelError": "取消医嘱失败",
      "completeSuccess": "医嘱已标记为完成",
      "completeError": "完成医嘱失败",
      "noActiveEncounter": "未找到该患者的有效就诊。请先创建就诊。",
      "placedSuccess_one": "成功提交 {{count}} 条医嘱",
      "placedSuccess_other": "成功提交 {{count}} 条医嘱",
      "medicationFieldsRequired_one": "{{names}} 需填写剂量、给药途径和频次后才能开具",
      "medicationFieldsRequired_other": "{{count}} 种药物需填写剂量、给药途径和频次：{{names}}",
      "medicationNotInFormulary_one": "{{names}} 未关联药品目录，无法进行过敏、相互作用或剂量筛查——请在药品页面开具",
      "medicationNotInFormulary_other": "{{count}} 种药物未关联药品目录，无法筛查：{{names}}——请在药品页面开具",
      "placedError_one": "{{count}} 条医嘱提交失败",
      "placedError_other": "{{count}} 条医嘱提交失败",
      "orderSetApplied": "已从「{{name}}」添加 {{count}} 条医嘱——签署前请复核"
    }
  },
  "catalog": "医嘱目录",
  "orderedBy": "开嘱医生",
  "orderedDate": "开嘱日期",
  "scheduledDate": "预定日期",
  "completedDate": "完成日期",
  "lab": "检验",
  "imaging": "影像",
  "medication": "药物",
  "procedure": "手术/操作",
  "consultation": "会诊",
  "priority": {
    "label": "优先级",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "加急",
      "routine": "常规",
      "scheduled": "预定",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "医嘱状态",
    "values": {
      "draft": "草稿",
      "pending": "待处理",
      "pendingCosign": "待会签",
      "signed": "已签署",
      "sent": "已发送",
      "active": "生效中",
      "ordered": "已下达",
      "inProgress": "执行中",
      "holdForVerify": "待核对",
      "completed": "已完成",
      "cancelled": "已取消",
      "discontinued": "已停止",
      "archived": "已归档",
      "pendingClarification": "待澄清",
      "suspended": "已暂停",
      "unknown": "未知"
    }
  },
  "entryFields": {
    "searchPlaceholder": "搜索医嘱（检验、影像、药物、操作）…",
    "frequency": "频次",
    "dose": "剂量",
    "route": "给药途径",
    "indication": "适应症",
    "duration": "持续时间",
    "comments": "备注",
    "signOrder": "签署医嘱",
    "holdOrder": "暂缓医嘱",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "医嘱目录",
    "searchPlaceholder": "按名称、代码或同义词搜索…",
    "categories": "分类",
    "favorites": "收藏",
    "recentlyUsed": "最近使用",
    "restricted": "受限项",
    "searchCatalog": "搜索目录",
    "tabs": {
      "all": "全部",
      "lab": "检验",
      "imaging": "影像",
      "medication": "药物",
      "procedure": "操作",
      "consultation": "会诊"
    },
    "columns": {
      "orderName": "医嘱名称",
      "code": "代码",
      "category": "类别",
      "description": "描述",
      "defaultPriority": "默认优先级"
    },
    "details": {
      "orderCode": "医嘱代码",
      "category": "类别",
      "defaultPriority": "默认优先级",
      "status": "状态",
      "cptCode": "CPT 代码",
      "loincCode": "LOINC 代码",
      "synonyms": "同义词",
      "description": "描述",
      "active": "启用",
      "inactive": "停用"
    },
    "loading": "正在加载目录…",
    "loadError": "加载医嘱目录失败",
    "emptyResults": "未找到符合条件的医嘱。",
    "pagination": "显示第 {{from}}-{{to}} 条，共 {{total}} 条",
    "pageIndicator": "第 {{page}} 页，共 {{totalPages}} 页",
    "favoriteAdd": "加入收藏",
    "favoriteRemove": "取消收藏",
    "favoriteAdded": "已加入收藏",
    "favoriteRemoved": "已取消收藏"
  },
  "cosign": {
    "title": "医嘱会签队列",
    "requiresCosign": "需要会签",
    "cosignedBy": "会签人",
    "cosignDeadline": "会签截止时间",
    "queueEmpty": "无需会签的医嘱。",
    "pendingCount": "待处理 {{count}} 条",
    "loading": "正在加载会签队列…",
    "loadError": "加载会签队列失败。",
    "columns": {
      "patient": "患者",
      "order": "医嘱",
      "type": "类型",
      "orderingProvider": "开嘱医生",
      "priority": "优先级",
      "orderedDate": "开嘱日期",
      "action": "操作"
    },
    "actions": {
      "cosign": "会签"
    },
    "toast": {
      "success": "医嘱会签成功",
      "error": "医嘱会签失败"
    },
    "cosigningAs": "以 {{name}} 身份会签"
  },
  "sets": {
    "title": "医嘱套餐",
    "newOrderSet": "新建医嘱套餐",
    "addItem": "添加项目",
    "requiredItem": "必选",
    "optionalItem": "可选",
    "editMode": "编辑模式",
    "published": "已发布",
    "draft": "草稿",
    "archived": "已归档",
    "versionNotes": "版本说明",
    "createTitle": "创建新医嘱套餐",
    "fields": {
      "name": "名称",
      "category": "类别",
      "specialty": "专科",
      "description": "描述"
    },
    "placeholders": {
      "name": "例如：胸痛诊查",
      "categorySelect": "选择类别…",
      "specialty": "例如：急诊医学",
      "description": "简短描述…",
      "search": "搜索医嘱套餐…"
    },
    "categories": {
      "chestPain": "胸痛",
      "sepsis": "脓毒症",
      "postOp": "术后",
      "admission": "入院",
      "discharge": "出院",
      "other": "其他"
    },
    "statusFilter": {
      "all": "全部状态",
      "active": "生效",
      "draft": "草稿",
      "archived": "已归档"
    },
    "columns": {
      "name": "名称",
      "category": "类别",
      "specialty": "专科",
      "items": "项目数",
      "status": "状态",
      "version": "版本",
      "actions": "操作"
    },
    "itemColumns": {
      "seq": "序号",
      "type": "类型",
      "item": "项目",
      "priority": "优先级",
      "required": "必选"
    },
    "itemTypes": {
      "order": "医嘱",
      "sectionHeader": "分节标题",
      "instruction": "说明"
    },
    "actions": {
      "publish": "发布",
      "archive": "归档",
      "cancel": "取消",
      "create": "创建",
      "removeItem": "移除项目"
    },
    "loading": "正在加载医嘱套餐…",
    "loadError": "加载医嘱套餐失败",
    "emptyResults": "未找到医嘱套餐。",
    "expandLoading": "正在加载项目…",
    "expandEmpty": "此医嘱套餐无项目。",
    "validationRequired": "名称、类别和专科为必填项",
    "toast": {
      "created": "医嘱套餐已创建",
      "createError": "创建医嘱套餐失败",
      "published": "医嘱套餐已发布",
      "publishError": "发布医嘱套餐失败",
      "archived": "医嘱套餐已归档",
      "archiveError": "归档医嘱套餐失败",
      "itemRemoved": "项目已移除",
      "itemRemoveError": "移除项目失败"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "搜索医嘱（检验、影像、药物、操作）…",
    "noResults": "未找到与 \"{{query}}\" 匹配的医嘱",
    "categories": {
      "all": "全部",
      "lab": "检验",
      "imaging": "影像",
      "med": "药物",
      "procedure": "操作",
      "consultation": "会诊"
    },
    "addAll": "全部添加（{{count}}）"
  },
  "worklist": {
    "title": "医嘱工作列表",
    "countBadge": "{{count}} 条医嘱",
    "loading": "正在加载医嘱…",
    "loadError": "无法加载医嘱，请重试。",
    "empty": "没有符合当前筛选条件的医嘱。",
    "typeLabel": "医嘱类型",
    "allOption": "全部",
    "columns": {
      "patient": "患者",
      "order": "医嘱",
      "type": "类型",
      "priority": "优先级",
      "status": "状态",
      "ordered": "开立时间"
    }
  }
}
